<template>
  <div class="trtc-call-root">
    <video-view
      v-if="isShowVideo"
      @closeCall="closeCall"
      @changeAudio="changeAudio"
      @changeShowSelf="changeShowSelf"
      my-video-view-dom-id="my-video-view"
      her-video-view-dom-id="her-video-view"
      :viewLoading="viewLoading"
      :call-loading="callLoading"
      :title="`呼叫给${herUserId}的通话`"
      :visibleSync="isShowVideo">
    </video-view>
    <listener @handleInviteeLineBusy="handleInviteeLineBusy"
              @handleUserAccept="handleUserAccept"
              @handleUserEnter="handleUserEnter"
              @handleInviteeReject="handleInviteeReject"
              @handleNoResponse="handleNoResponse"
              @handleCallTimeout="handleCallTimeout"
              @handleUserAudioChange="handleUserAudioChange"
              @handleUserVideoChange="handleUserVideoChange"
              @handleCallEnd="handleCallEnd"
              @ready="ready"
    ></listener>
  </div>

</template>

<script>
  import {genTestUserSig} from './GenerateTestUserSig'
  import videoView from './videoView'
  import listener from './listener.vue'

  export default {
    name: 'trtcCall',
    components: {
      listener,
      videoView
    },
    props: {
      myUserId: {
        type: [String, Number],
      },
      herUserId: {
        type: [String, Number],
      },
      projectId: {
        type: [String, Number],
      }
    },
    data() {
      return {
        calling: false,
        viewLoading: false,
        isShowVideo: false,
        videoInit: false,
        audioInit: false,
        callLoading: true,
      }
    },
    methods: {
      changeAudio(audioSelf) {
        this.$trtcCalling.setMicMute(!audioSelf)
      },
      changeShowSelf(showSelf) {
        if (showSelf) {
          this.$trtcCalling.openCamera()
        } else {
          this.$trtcCalling.closeCamera()
        }
      },
      closeCall() {
        this.$trtcCalling.hangup()
          .then(res => {
            this.isShowVideo = false
            this.calling = false
            this.$emit('close')
          })

      },
      cancelCall() {
        this.$trtcCalling.hangup()
        this.calling = false
        this.$message.warning(`通话已取消`)
      },
      handleUserAccept({userID}) {
        //对方同意通话
        this.isShowVideo = true
        this.viewLoading = true
        this.callLoading = false
        this.calling = true
        this.$message.success(`${userID}已同意通话`)
      },
      handleInviteeLineBusy({userID}) {
        //对方忙线
        this.$message.warning(`${userID}忙线`)
        if (this.calling) return
        this.calling = false
        this.callLoading = false
        this.reCall()
      },
      handleCallEnd() {
        //通话结束
        this.$message.warning(`通话结束`)
        this.calling = false
        this.isShowVideo = false
        this.videoInit = false
        this.audioInit = false
        this.callLoading = false
        this.$emit('close')
      },
      handleUserEnter({userID}) {
        //对方进入
        this.$nextTick(async () => {
          await this.$trtcCalling.startLocalView({
            userID: this.$trtcCalling._userID,
            videoViewDomID: `my-video-view`
          })
          await this.$trtcCalling.startRemoteView({
            userID: userID,
            videoViewDomID: `her-video-view`
          })
          this.callLoading = false
          this.viewLoading = false
        })
      },
      handleUserVideoChange: function ({userID, isVideoAvailable}) {
        if (!this.videoInit) {
          this.videoInit = true
          return
        }
        //摄像头状态变化
        if (isVideoAvailable) {
          this.$message.warning('对方开启了摄像头')
        } else {
          this.$message.warning('对方关闭了摄像头')
        }
      },
      handleUserAudioChange: function ({userID, isAudioAvailable}) {
        //麦克风状态变化
        if (!this.audioInit) {
          this.audioInit = true
          return
        }
        if (isAudioAvailable) {
          this.$message.warning('对方开启了麦克风')
        } else {
          this.$message.warning('对方关闭了麦克风')
        }
      },
      handleCallTimeout({userID}) {
        //超时
        this.$message.warning(`${userID}呼叫超时`)
        this.calling = false
        this.callLoading = false
        this.reCall()
      },
      handleNoResponse({userID}) {
        //无应答
        this.$message.warning(`${userID}无应答`)
        this.calling = false
        this.callLoading = false
        this.reCall()
      },
      handleInviteeReject: async function ({userID}) {
        //对方拒绝通话
        this.$message.warning(`${userID}拒绝通话`)
        this.calling = false
        this.callLoading = false
        this.reCall()
      },
      reCall() {
        let owner = this
        this.$msgbox.confirm('是否重新拨打', {
            confirmButtonText: '重新拨打',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          this.callLoading = true
          owner.call()
        }).catch(e => {
          owner.$emit('close')
        })
      },
      ready(param) {
        let {myUserId, herUserId} = this
        if (!myUserId || myUserId.toString() === '' || !herUserId || herUserId.toString() === '') return
        this.isShowVideo = true
        this.$nextTick(() => {
          this.call()
        })
      },
      loginTrtc() {
        if (this.$trtcCalling._userID == null || this.$trtcCalling._userID != this.myUserId) {
          this.$trtcCalling.login({
            userID: this.myUserId,
            userSig: genTestUserSig(this.myUserId).userSig
          })
        }
      },
      call() {
        if (this.herUserId === this.$trtcCalling._userID) {
          this.$message.warning('不能与自己通话')
          return
        }
        this.$trtcCalling.call({
          userID: this.herUserId,
          type: 2,//，0-未知， 1-语音通话，2-视频通话
          timeout: 70
        })

      }
    },
    destroyed() {
      if (this.$trtcCalling._callStatus === 'connected') {
        this.$trtcCalling.hangup()
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.loginTrtc()
      })
    }
  }
</script>

<style scoped>
  .trtc-call-root {
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/TrtcCall/index.vue